import React from 'react';
import PropTypes from 'prop-types';
import useIntercom from 'use-intercom-hook';
import { connect } from 'react-redux';
import { userSelector } from '../../selectors';

const intercomId = process.env.REACT_APP_INTERCOM_APP_ID;
const IntercomContainer = ({
  currentUser,
}) => {
  if (!intercomId) {
    return null;
  }
  if (!currentUser || !currentUser.intercomHash) {
    useIntercom(intercomId);
    return (<div />);
  }
  useIntercom(intercomId, {
    user_id: currentUser.id,
    name: currentUser.name,
    email: currentUser.email,
    user_hash: currentUser.intercomHash,
    language_override: currentUser.emailLocale,
  });
  return (<div />);
};

IntercomContainer.propTypes = {
  currentUser: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    email: PropTypes.string,
    intercomHash: PropTypes.string,
    emailLocale: PropTypes.string,
  }),
};

export default connect((state) => ({
  currentUser: userSelector(state),
}))(IntercomContainer);
